import '../assets/css/normalize.css'
import '../assets/css/main.css'

import 'angular-animate'
// import 'angular-ui-router'
require('es6-promise/auto')

const arrowUp = require('../assets/icons/arrow-up.svg')
const arrowDown = require('../assets/icons/arrow-down.svg')
const arrowLeft = require('../assets/icons/arrow-left.svg')
const arrowRight = require('../assets/icons/arrow-right.svg')
const arrowVertical = require('../assets/icons/arrow-vertical.svg')
const cancel = require('../assets/icons/cancel.svg')
const cart = require('../assets/icons/cart.svg')
const fileDoc = require('../assets/icons/file-doc.svg')
const filePdf = require('../assets/icons/file-pdf.svg')
const callback = require('../assets/icons/callback.svg')
const fileJpg = require('../assets/icons/file-jpg.svg')
const menu = require('../assets/icons/menu.svg')
const phone = require('../assets/icons/phone.svg')
// const check = require('../assets/icons/check.svg')
const checkmark = require('../assets/icons/checkmark.svg')
const checkmarkOutline = require('../assets/icons/checkmark-outline.svg')
const refresh = require('../assets/icons/refresh.svg')
const email = require('../assets/icons/email.svg')
const arrowRightCircle = require('../assets/icons/arrow-right-circle.svg')
const facebook = require('../assets/icons/facebook.svg')
const google = require('../assets/icons/google.svg')
const instagram = require('../assets/icons/instagram.svg')
const link = require('../assets/icons/link.svg')
const linkedin = require('../assets/icons/linkedin.svg')
const pinterest = require('../assets/icons/pinterest.svg')
const plusCircle = require('../assets/icons/plus-circle.svg')
const plus = require('../assets/icons/plus.svg')
const star = require('../assets/icons/star.svg')
const twitter = require('../assets/icons/twitter.svg')
const playCircle = require('../assets/icons/play-circle.svg')
const youtube = require('../assets/icons/youtube.svg')
const search = require('../assets/icons/search.svg')
const notification = require('../assets/icons/notification.svg')
const print = require('../assets/icons/print.svg')

const imgPlaceholder640 = require('../assets/img/img-placeholder-640.png')
const logo = require('../assets/img/logo.svg')
const orderNow600X338 = require('../assets/img/order-now-600-x-338.png')
const pdf = require('../assets/img/pdf.png')

import '../assets/js/main.js'

import './modules/ATMGApi/ATMGApi.js'
import './modules/Cart/CartModule.js'

import './modules/ATMGApi/factories/AddressBook.js'
import './modules/ATMGApi/factories/ApiQuery.js'
import './modules/ATMGApi/factories/Customer.js'
import './modules/ATMGApi/factories/Shipping.js'
import './modules/ATMGApi/services/Store.js'
import './modules/Cart/services/CartService.js'

import './modules/ATMGUser/ATMGUser.js'
import './modules/Cart/services/Checkout.js'
import './modules/Cart/classes/Video.js'
import './modules/Cart/services/Cart.js'
import './modules/ATMGAuth/ATMGAuth.js'
import './modules/ATMGLogin/ATMGLogin.js'
import './modules/angular-once/angular-once.js'
import './modules/ATMGCheckout/ATMGCheckout.js'
import './modules/ATMGCheckout/controllers/ConfirmationController.js'
import './modules/ATMGCheckout/controllers/CustomerNotesController.js'
import './modules/P3in/P3in.js'
import './modules/P3in/directives/drop-down.js'
import './modules/P3in/directives/p3BindHtml.js'
import './modules/P3in/directives/csv-download.js'
import './modules/P3in/directives/lb2br.js'
import './modules/io-service/io-service.js'
import './modules/google-analytics/angular-google-analytics.js'

// svg4everybody()

import './ATMGurus.js'
import './services/OracleStatusMonitor.js'
import './controllers/MainController.js'
import './controllers/ContentController.js'
import './controllers/TrainingController.js'

import './controllers/RegisterController.js'
import './controllers/StoreController.js'
import './controllers/SingleProductController.js'
import './controllers/AccountController.js'
import './controllers/AccountDetailsController.js'

import './filters/capitalize.js'
import './filters/splitBy.js'
import './filters/lowercase.js'
import './filters/tel.js'
import './filters/unsafe.js'
import './filters/trustAsResourceUrl.js'

import './directives/PasswordMatching.js'
import './directives/pagination.js'
import './directives/breadcrumbs.js'
import './directives/labelPrint.js'


import './directives/navMenu.js'
import './directives/trainingSchedule.js'
import './directives/company-input.js'
import './directives/dropdown-input.js'
import './directives/autofillSync.js'
import './directives/atmg-table.js'
import './directives/videoLinks.js'
import './directives/pdfDownload.js'
import './directives/img-fallback.js'
import './directives/prevent.js'
import './directives/nav-tritonmanual-menu.js'

import './providers/Navigation.js'

import './services/LoadingService.js'
import './services/ConsoleService.js'
import './services/ContentService.js'
import './services/ErrorService.js'
import './services/FilterService.js'
import './services/ATMGMyAccountService.js'
import './services/ClassesBookingService.js'
import './services/FormService.js'
import './services/Lookup.js'
import './components/modal-component.js'
import './components/atmgNav.js'
import './components/atmgHead.js'
import './components/atmgFoot.js'


// WEBPACK FOOTER //
// ./src/app/app.js